import React from "react";

/**
 * Logo DoctoDays — DD+ green rounded square with medical cross badge.
 * Matches exactly the favicon design.
 *
 * Sizes:
 *  - xs: 24px, sm: 32px, md: 40px (default), lg: 56px, xl: 80px, xxl: 112px
 *
 * Props:
 *  - size: predefined keyword above
 *  - withText: render "DoctoDays" wordmark beside the badge
 *  - textClassName: override typography
 *  - className: wrapper override
 */
const SIZES = {
  xs: { box: 24, text: 10, cross: 10, radius: 6 },
  sm: { box: 32, text: 13, cross: 12, radius: 8 },
  small: { box: 32, text: 13, cross: 12, radius: 8 },
  md: { box: 40, text: 17, cross: 14, radius: 10 },
  default: { box: 40, text: 17, cross: 14, radius: 10 },
  lg: { box: 56, text: 24, cross: 18, radius: 13 },
  large: { box: 64, text: 28, cross: 22, radius: 14 },
  xl: { box: 80, text: 34, cross: 26, radius: 18 },
  xxl: { box: 112, text: 48, cross: 36, radius: 24 },
};

export const Logo = ({
  size = "md",
  withText = false,
  textClassName = "",
  className = "",
}) => {
  const s = SIZES[size] || SIZES.md;
  // Cross badge position
  const badgeSize = s.cross;
  const crossStroke = Math.max(2, Math.round(badgeSize * 0.32));
  const crossLen = Math.round(badgeSize * 0.5);

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <span
        className="relative inline-flex items-center justify-center shrink-0 shadow-lg shadow-emerald-600/25"
        style={{
          width: s.box,
          height: s.box,
          backgroundColor: "#059669",
          borderRadius: s.radius,
        }}
        aria-label="Logo DoctoDays"
      >
        <span
          className="font-black text-white tracking-tight select-none"
          style={{ fontSize: s.text, letterSpacing: "-0.04em" }}
        >
          DD
        </span>
        {/* White circle with green + */}
        <span
          className="absolute -top-1 -right-1 inline-flex items-center justify-center"
          style={{
            width: badgeSize,
            height: badgeSize,
            backgroundColor: "white",
            borderRadius: "9999px",
          }}
        >
          {/* vertical bar */}
          <span
            className="absolute"
            style={{
              width: crossStroke,
              height: crossLen,
              backgroundColor: "#059669",
              borderRadius: crossStroke / 2,
            }}
          />
          {/* horizontal bar */}
          <span
            className="absolute"
            style={{
              width: crossLen,
              height: crossStroke,
              backgroundColor: "#059669",
              borderRadius: crossStroke / 2,
            }}
          />
        </span>
      </span>
      {withText && (
        <span
          className={`font-black tracking-tight text-slate-900 ${textClassName}`}
          style={{ letterSpacing: "-0.03em" }}
        >
          Docto<span className="text-emerald-600">Days</span>
        </span>
      )}
    </span>
  );
};

export default Logo;
